export const isArrayValid = array => array != null && array.length !== 0
